import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function shallowEqualArrays(arrA, arrB) {
  var equal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (a, b) {
    return a === b;
  };
  if (arrA === arrB) return true;
  if (!arrA || !arrB) return false;
  var len = arrA.length;
  if (arrB.length !== len) return false;

  for (var i = 0; i < len; i++) {
    if (!equal(arrA[i], arrB[i])) return false;
  }

  return true;
}

var globalCache = [];

function query(fn, keys) {
  var preload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var config = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var _iterator = _createForOfIteratorHelper(globalCache),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _entry = _step.value;

      // Find a match
      if (shallowEqualArrays(keys, _entry.keys, _entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw

        if (Object.prototype.hasOwnProperty.call(_entry, 'error')) throw _entry.error; // If a response was successful, return

        if (Object.prototype.hasOwnProperty.call(_entry, 'response')) return _entry.response; // If the promise is still unresolved, throw

        if (!preload) throw _entry.promise;
      }
    } // The request is new or has changed.

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var entry = {
    keys: keys,
    equal: config.equal,
    promise: // Execute the promise
    fn.apply(void 0, _toConsumableArray(keys)) // When it resolves, store its value
    .then(function (response) {
      return entry.response = response;
    }) // Remove the entry if a lifespan was given
    .then(function () {
      if (config.lifespan && config.lifespan > 0) {
        setTimeout(function () {
          var index = globalCache.indexOf(entry);
          if (index !== -1) globalCache.splice(index, 1);
        }, config.lifespan);
      }
    }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
    .catch(function (error) {
      return entry.error = error;
    })
  }; // Register the entry

  globalCache.push(entry); // And throw the promise, this yields control back to React

  if (!preload) throw entry.promise;
  return undefined;
}

var suspend = function suspend(fn, keys, config) {
  return query(fn, keys, false, config);
};

var preload = function preload(fn, keys, config) {
  return void query(fn, keys, true, config);
};

var peek = function peek(keys) {
  var _globalCache$find;

  return (_globalCache$find = globalCache.find(function (entry) {
    return shallowEqualArrays(keys, entry.keys, entry.equal);
  })) == null ? void 0 : _globalCache$find.response;
};

var clear = function clear(keys) {
  if (keys === undefined || keys.length === 0) globalCache.splice(0, globalCache.length);else {
    var entry = globalCache.find(function (entry) {
      return shallowEqualArrays(keys, entry.keys, entry.equal);
    });

    if (entry) {
      var index = globalCache.indexOf(entry);
      if (index !== -1) globalCache.splice(index, 1);
    }
  }
};

export { clear, peek, preload, suspend };